import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import ActivityCards from 'containers/Dashboard/Activity/ActivityCards';
import FloorPlans from 'containers/Dashboard/Activity/FloorPlans';
import Timelines from 'containers/Dashboard/Activity/Timelines';
import EmployeeStatus from 'containers/Dashboard/Activity/EmployeeStatus';
import SharedCanvas from 'containers/Dashboard/components/SharedCanvas';
import { useDashboardContext } from 'containers/Dashboard/context/DashboardContext';
import { resolveActivityCanvasId } from 'containers/Dashboard/utils/dashboardCanvases';

function ActivityCanvas() {
  const params = Route.useParams();
  const canvasId = resolveActivityCanvasId(params.canvasId);
  const {
    authtoken,
    selectedDate,
    handleSelectedDateChange,
    teepData,
    resources,
    facilityData,
    locatingFacilityData,
    windowSize,
    isLoading,
  } = useDashboardContext();

  if (canvasId === 'activity_cards') {
    return (
      <ActivityCards
        authtoken={authtoken}
        selectedDate={selectedDate}
        handleSelectedDateChange={handleSelectedDateChange}
        teepData={teepData}
        resources={resources}
      />
    );
  }
  if (canvasId === 'summary') {
    return (
      <FloorPlans
        teepData={teepData}
        facilityData={facilityData}
        locatingFacilityData={locatingFacilityData}
        windowSize={windowSize}
        authtoken={authtoken}
      />
    );
  }
  if (canvasId === 'timelines') {
    return (
      <Timelines
        authtoken={authtoken}
        selectedDate={selectedDate}
        handleSelectedDateChange={handleSelectedDateChange}
        teepData={teepData}
        resources={resources}
        isLoading={isLoading}
      />
    );
  }
  if (canvasId === 'employee_status') {
    return <EmployeeStatus authtoken={authtoken} />;
  }
  return <SharedCanvas dashboard="activity" canvasId={canvasId} />;
}

export const Route = createFileRoute(
  '/_authenticated/dashboard/activity/$canvasId'
)({
  component: ActivityCanvas,
});
